import { SELECT_INPUT_TYPE, Yup } from "@mavichpe/dynamic-forms";

const ListPriceFormConfig = {
    submit: {
        label: "Imprimir"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "priceId",
                        "label": "Tipo de Precio",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 7
                        },
                        "validation": Yup.string().required(),
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "onlyOnInventory",
                        "label": "Incluir solo productos con inventario",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        }
                    }
                ],
            ]
        }
    ],
};


export default ListPriceFormConfig;